export default "__VITE_ASSET__Op4woVIP__"